<template>
    <b-container>
        <!-- <validation-observer ref="simpleRules"> -->
        <b-row>
            <b-col sm="6">
                <validation-provider
                #default="{ errors }"
                name="Time"
                rules="required"
                >
                <b-form-group>
                    <template #label>
                        Time Portfolio <span class="text-danger">*</span>
                    </template>
                    <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="options.timePortfolios"
                    v-model="content.timePortfolio"
                    />
                    <small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small>
                </b-form-group>
                </validation-provider>
            </b-col>
            <b-col sm="6">
                <validation-provider
                #default="{ errors }"
                name="CFU"
                rules="required"
                >
                    <b-form-group>
                        <template #label>
                            CFU <span class="text-danger">*</span>
                        </template>
                        <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="name"
                        multiple
                        :options="options.cfus"
                        @input="onCfuInput"
                        v-model="content.cfu"
                        />
                    <small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small>
                    </b-form-group>
                </validation-provider>
            </b-col>
            <b-col sm="6">
                <validation-provider
                #default="{ errors }"
                name="CFU Businessline"
                rules="required"
                >
                    <b-form-group>
                        <template #label>
                            CFU Businessline <span class="text-danger">*</span>
                        </template>
                        <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="name"
                        multiple
                        :options="options.cfusBusiness"
                        @input="onCfuBusinessInput"
                        v-model="content.cfu_business_line"
                        />
                        <small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small>
                        <br v-if="errors.length > 0 && errChildBussinessLine"/>
                        <small v-if="errChildBussinessLine" class="text-danger" > Choose business line of {{errChildBussinessLine}}! </small>
                    </b-form-group>
                </validation-provider>
            </b-col>
            <b-col sm="6">
                <validation-provider
                #default="{ errors }"
                name="Division"
                rules="required"
                >
                    <b-form-group>
                        <template #label>
                            Division <span class="text-danger">*</span>
                        </template>
                        <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="division"
                        :options="options.divisions"
                        v-model="content.division"
                        multiple
                        />
                        <small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small>
                        <br v-if="errors.length > 0 && errDivision"/>
                        <small v-if="errDivision" class="text-danger" > Choose division of {{errDivision}} ! </small>
                    </b-form-group>
                </validation-provider>
            </b-col>
            <b-col sm="6">
                <validation-provider
                #default="{ errors }"
                name="CFU Productline"
                rules="required"
                >
                    <b-form-group>
                        <template #label>
                            CFU Productline <span class="text-danger">*</span>
                        </template>
                        <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="name"
                        multiple
                        :options="options.cfusProduct"
                        v-model="content.cfu_product_line"
                        />
                        <small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small>
                        <br v-if="errors.length > 0 && errChildProductLine"/>
                        <small v-if="errChildProductLine" class="text-danger" > Choose product line of {{errChildProductLine}} ! </small>
                    </b-form-group>
                </validation-provider>
            </b-col>
            <!-- <b-col sm="6">
                <validation-provider
                #default="{ errors }"
                name="STP Type"
                rules="required"
                >
                    <b-form-group>
                        <template #label>
                            STP <span class="text-danger">*</span>
                        </template>
                        <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="stp"
                        multiple
                        :options="options.stpType"
                        v-model="content.stpType"
                        />
                        <small class="text-danger" v-for="(data, index) in errors" :key="index">{{ data }}</small> -->
                        <!-- <br v-if="errors.length > 0 && errChildProductLine"/>
                        <small v-if="errChildProductLine" class="text-danger" > Choose product line of {{errChildProductLine}} ! </small> -->
                    <!-- </b-form-group>
                </validation-provider> -->
            <!-- </b-col> -->
            <b-col sm="6">
                <b-form-group>
                    <template #label>
                        Partner 
                    </template>
                    <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="COMPANY_NAME"
                    :options="options.partnerList"
                    v-model="content.partner"
                    />
                </b-form-group>
            </b-col>
            <b-col sm="12">
                <b-form-group>
                    Parent
                    <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="PRODUCT"
                    :options="options.productList"
                    v-model="content.parent"
                    />
                </b-form-group>
            </b-col>
            <b-col sm="6">
                Banner Website <span class="desc">(resolusi 1200px x 350px)</span>
                <existing-file-list :files="content.existing_banner_web" />
                <div id="banner_web" class="dropzone dropzone-area mb-3">
                    <div class="dz-message"><feather-icon size="50" icon="DownloadIcon" /></div>

                </div>
            </b-col>
            <b-col sm="6">
                Banner Mobile <span class="desc">(resolusi 45px x 45px)</span>
                <existing-file-list :files="content.existing_banner_mobile" />
                <div id="banner_mobile" class="dropzone dropzone-area mb-3">
                    <div class="dz-message"><feather-icon size="50" icon="DownloadIcon" /></div>

                </div>
            </b-col>
            <b-col sm="6">
                Photo Product
                <existing-file-list :files="content.existing_photo_product" />
                <div id="photo_product" class="dropzone dropzone-area mb-3">
                    <div class="dz-message"><feather-icon size="50" icon="DownloadIcon" /></div>

                </div>
            </b-col>
        </b-row>
        <b-modal
        id="modal-login"
        cancel-variant="outline-secondary"
        ok-title="Ok"
        cancel-title="Close"
        centered
        title="Name"
        ref="nameModal"
        @ok="setCurrentFile"
        >
        <b-form>
            <b-form-group>
            <label for="name">Name:</label>
            <b-form-input
                id="name"
                placeholder="Name File"
                v-model="currentFileName"
            />
            </b-form-group>
        </b-form>
        </b-modal>
        <!-- </validation-observer> -->
    </b-container>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import { BModal } from 'bootstrap-vue'
import { BLink, BImg, BContainer, BRow, BCol, BCard, BForm, BFormGroup, BFormInput, BButton, BProgress, BCardText, BDropdown, BDropdownItem, BOverlay, BBadge } from 'bootstrap-vue'

// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ExistingFileList from './ExistingFileList.vue'
export default {
    props: {
        content: Object,
        options: Object,
        methods: Object,
        dropzoneElements: Object,
    },
    components: {
        BCardText,
        BTabs,
        BTab,
        BLink,
        BImg,
        BCol,
        BContainer,
        BRow,
        BCard,
        BProgress,
        BCardText,
        BDropdown,
        BDropdownItem,
        BButton,
        BForm,
        BFormGroup,
        BFormInput,
        BOverlay,
        BModal,
        BBadge,
        vSelect,
        quillEditor,
        ExistingFileList,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            currentFile: '',
            currentFileName: '',
            banner_web: null,
            banner_mobile: null,
            errChildBussinessLine: null,
            errChildProductLine: null,
            errDivision: null,
        }
    },
    watch: {
        'content.cfu': function (val, oldVal) {
            if (!Array.isArray(this.content.cfu) || (Array.isArray(this.content.cfu) && this.content.cfu.length < 1)) {
                this.errChildBussinessLine = null
            }
            for (let index = 0; index < this.content.cfu.length; index++) {
                let item  = this.content.cfu[index];
                if (!Array.isArray(this.content.cfu_business_line)) {
                    this.errChildBussinessLine = item.name
                    break;
                }
                let result = this.checkChild(item, 'id', this.content.cfu_business_line, 'cfu_id')
                if (!result) {
                    this.errChildBussinessLine = item.name
                    break;
                }
                this.errChildBussinessLine = null
            }

            if (!Array.isArray(this.content.cfu) || (Array.isArray(this.content.cfu) && this.content.cfu.length < 1)) {
                this.errDivision = null
            }

            for (let index = 0; index < this.content.cfu.length; index++) {
                let item  = this.content.cfu[index];
                if (!Array.isArray(this.content.division)) {
                    this.errDivision = item.name
                    break;
                }
                let result = this.checkChild(item, 'id', this.content.division, 'cfu_id')
                if (!result) {
                    this.errDivision = item.name
                    break;
                }
                this.errDivision = null
            }
        },
        'content.cfu_business_line': function (val, oldVal) {
            for (let index = 0; index < this.content.cfu.length; index++) {
                let item  = this.content.cfu[index];
                if (!Array.isArray(this.content.cfu_business_line)) {
                    this.errChildBussinessLine = item.name
                    break;
                }
                let result = this.checkChild(item, 'id', this.content.cfu_business_line, 'cfu_id')
                if (!result) {
                    this.errChildBussinessLine = item.name
                    break;
                }
                this.errChildBussinessLine = null
            }

            if (!Array.isArray(this.content.cfu_business_line) || (Array.isArray(this.content.cfu_business_line) && this.content.cfu_business_line.length < 1)) {
                this.errChildProductLine = null
            }

            for (let index = 0; index < this.content.cfu_business_line.length; index++) {
                let item  = this.content.cfu_business_line[index];
                if (!Array.isArray(this.content.cfu_product_line)) {
                    this.errChildProductLine = item.name
                    break;
                }
                let result = this.checkChild(item, 'id', this.content.cfu_product_line, 'cfu_business_line_id')
                if (!result) {
                    this.errChildProductLine = item.name
                    break;
                }
                this.errChildProductLine = null
            }
            
        },
        'content.cfu_product_line': function (val, oldVal) {
            for (let index = 0; index < this.content.cfu_business_line.length; index++) {
                let item  = this.content.cfu_business_line[index];
                if (!Array.isArray(this.content.cfu_product_line)) {
                    this.errChildProductLine = item.name
                    break;
                }
                let result = this.checkChild(item, 'id', this.content.cfu_product_line, 'cfu_business_line_id')
                if (!result) {
                    this.errChildProductLine = item.name
                    break;
                }
                this.errChildProductLine = null
            }
        },
        'content.division': function (val, oldVal) {
            for (let index = 0; index < this.content.cfu.length; index++) {
                let item  = this.content.cfu[index];
                if (!Array.isArray(this.content.division)) {
                    this.errDivision = item.name
                    break;
                }
                let result = this.checkChild(item, 'id', this.content.division, 'cfu_id')
                if (!result) {
                    this.errDivision = item.name
                    break;
                }
                this.errDivision = null
            }
        }

        
    },
    mounted() {
        let vm = this
        let options = {
                url: process.env.VUE_APP_API_URL + '/dummy',
                maxFiles: 1,
                autoProcessQueue: true,
                autoQueue: true,
                addRemoveLinks: true,
                acceptedFiles: 'image/jpeg,image/jpg',
                accept: function (file, done) {
                    let mapContainerId = 'map_'+this.element.id
                    vm.mapContainerId = mapContainerId
                    vm.currentFile = file
                    vm.currentFileName = ''
                    vm.setCurrentFile()
                    // vm.showMsgBoxName()
                    file.accepted = true
                    file.status = 'success'
                    this.emit('success', file)
                    this.emit('complete', file)
                }
            
            }
        this.dropzoneElements.banner_web = new Dropzone("#banner_web", options)
        this.dropzoneElements.banner_mobile = new Dropzone("#banner_mobile", options)
        this.dropzoneElements.photo_product = new Dropzone("#photo_product", options)
    },
    methods: {
        onCfuInput(e) {
            this.content.cfu_product_line = ''
            this.content.cfu_business_line = ''
            this.content.division = ''
            let ids = '';
            e.forEach(element => {
               ids += element.id.toString() + ","
            });
            ids = ids.slice(0,-1)
            if (typeof ids == 'string' && e != null) {
                this.methods.onCfuChange(ids)
            }
        },
        onCfuBusinessInput(e) {
            this.content.cfu_product_line = ''
            let ids = '';
            e.forEach(element => {
               ids += element.id.toString() + ","
            });
            ids = ids.slice(0,-1)
            if (typeof ids == 'string' && ids != null) {
                this.methods.onCfuBusinessChange(ids)
            }
        },
        syncMedia() {
            this.content.banner_web = this.dropzoneElements.banner_web.getAcceptedFiles()
            this.content.banner_mobile = this.dropzoneElements.banner_mobile.getAcceptedFiles()
            this.content.photo_product = this.dropzoneElements.photo_product.getAcceptedFiles()
        },
        showMsgBoxName() {
            let vm = this
            vm.$refs.nameModal.show()
        },
        setCurrentFile() {
            let file = {
                name: this.currentFileName,
                file: this.currentFile
            }
            this.content[this.mapContainerId] = [...this.content[this.mapContainerId], file]
            this.currentFile = ''
            this.currentFileName = ''
        },
        setTempSelectedRelatedProduct(item) {
            let selected = null
            if (item.length > 0 ) {
                selected = item[0]
            }
            this.tempSelectedRelatedProduct = selected
        },
        setSelectedProduct() {
            this.content.relatedProduct.push(this.tempSelectedRelatedProduct)
            this.warningProduct = false
        },
        removeRelatedProductItem(kode) {
            this.content.relatedProduct = this.content.relatedProduct.filter(item => {
                return item.KODE !== kode
            })
        },
        checkChild(parent, parent_key, child, child_key) {
            let result = child.filter(item => item[child_key] == parent[parent_key])
            return result.length > 0
        }
    }
}
</script>

<style scoped>
.dropzone {
    min-height: 250px;
}
.dz-message:before {
    display: none;
}

.desc {
    color: #b8c2cc;
    font-size: 0.7rem;
    font-style: italic;
}
.dz-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
